
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1294.26 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"328.47","cy":"632.02","r":"81.38"}}),_c('path',{attrs:{"d":"M514.09 420.66l-30 12.74v56.28h-29.62v-77.42H410l-11.68 17L241 431.53 51 459v178.13l165.44 21.42a115.09 115.09 0 11224 0h180.12A98.53 98.53 0 01718 545.76c2.77 0 5.51.12 8.22.34l.25-62.92L835.56 456 857 427.38l150-44.21a15.82 15.82 0 0029.25-11.51h9.79l3.75-9s18.28-1 18.71-12.81l180 .37v3.62h13V315h-13l-468-.38h-13v38.85h13v-3.62h163.82c1.57 3.85 6.76 13.06 20.39 13.06.3.46.68 1.08 1.1 1.79l-303.07 68.08-4.26-12.12z"}}),_c('circle',{attrs:{"cx":"711.58","cy":"642.28","r":"59.45"}}),_c('path',{attrs:{"d":"M624.13 290.38H517.06v99.07h130.07l-23-99.07z"}})])
          )
        }
      }
    